import { render, staticRenderFns } from "./AcoesPINSS.vue?vue&type=template&id=294e05f6&scoped=true"
import script from "./AcoesPINSS.vue?vue&type=script&lang=js"
export * from "./AcoesPINSS.vue?vue&type=script&lang=js"
import style0 from "./AcoesPINSS.vue?vue&type=style&index=0&id=294e05f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294e05f6",
  null
  
)

export default component.exports